import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { markNewManagementAsUnderEnrolment } from '../service';

export function useUnderEnrolmentNewManagement({
    onSuccess = () => {},
    onError = () => {},
}: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
} = {}) {
    const queryClient = useQueryClient();
    const toast = useToast();

    const mutation = useMutation({
        mutationFn: async ({
            agencyPortfolioPropertyId,
        }: {
            agencyPortfolioPropertyId: number;
        }) => {
            await markNewManagementAsUnderEnrolment(agencyPortfolioPropertyId);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['integrated-properties'],
            });
            onSuccess();
        },
        onError: (error) => {
            toast({
                title: 'Failed to mark new management as under enrolment',
                description: `We experienced an error while trying to mark this property as under enrolment (${error.message})`,
                status: 'error',
                isClosable: true,
            });
            onError(error);
        },
    });

    return {
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        markAsUnderEnrolment: mutation.mutate,
    };
}
